import React from "react";
import { ArrowUpRight } from "lucide-react";
import "./TpcTradeFloorHostedSessions.css";

import hostedRoomImage from "../../images/Landscape/MCI2.webp";
import chartBg from "../../images/Chart 5.webp";

const sessionStats = [
  {
    id: "rooms",
    label: "Hosted Rooms",
    value: "02",
    trend: "gold",
  },
  {
    id: "focus",
    label: "Session Focus",
    value: "Levels + Risk",
    trend: "green",
  },
  {
    id: "outcome",
    label: "Outcome",
    value: "Floor-Ready",
    trend: "red",
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "gold",
  "green",
  "red",
  "green",
  "green",
  "gold",
  "red",
];

function TpcTradeFloorHostedSessions({
  ctaHref = "#tpc-trade-floors",
  ctaLabel = "Explore Trade Floors",
}) {
  return (
    <section
      id="tpc-hosted-trade-theory-rooms"
      className="trpc-tradeFloorSessions"
      aria-labelledby="trpc-tradeFloorSessions-title"
    >
      <div className="trpc-tradeFloorSessions-wrap">
        <article className="trpc-tradeFloorSessions-panel">
          <figure className="trpc-tradeFloorSessions-visual">
            <div className="trpc-tradeFloorSessions-media">
              <img
                className="trpc-tradeFloorSessions-photo"
                src={hostedRoomImage}
                alt="TPC instructors leading a live theory room before students enter the trade floor"
                loading="lazy"
                decoding="async"
              />

              <img
                className="trpc-tradeFloorSessions-chart"
                src={chartBg}
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
              />

              <div
                className="trpc-tradeFloorSessions-photoGrid"
                aria-hidden="true"
              />

              <div
                className="trpc-tradeFloorSessions-photoShade"
                aria-hidden="true"
              />

              <div
                className="trpc-tradeFloorSessions-terminalDots"
                aria-hidden="true"
              >
                <span />
                <span />
                <span />
              </div>

              <div
                className="trpc-tradeFloorSessions-routeCard"
                aria-hidden="true"
              >
                <span>Brief</span>
                <strong>→</strong>
                <span>Execute</span>
              </div>

              <div
                className="trpc-tradeFloorSessions-candleGroup"
                aria-hidden="true"
              >
                {marketCandles.map((trend, index) => (
                  <span
                    key={`${trend}-${index}`}
                    className="trpc-tradeFloorSessions-candle"
                    data-trend={trend}
                  />
                ))}
              </div>
            </div>

            <figcaption className="trpc-tradeFloorSessions-copy">
              <span className="trpc-tradeFloorSessions-kicker">
                Mentor-led preparation
              </span>

              <h2
                id="trpc-tradeFloorSessions-title"
                className="trpc-tradeFloorSessions-title"
              >
                <span>Plan first.</span>
                <span>Trade clear.</span>
              </h2>

              <p className="trpc-tradeFloorSessions-lead">
                Mentors set the levels, risk and scenarios before students move
                into live execution.
              </p>

              <a
                className="trpc-tradeFloorSessions-btn"
                href={ctaHref}
                data-candle="green"
              >
                <span>{ctaLabel}</span>
                <ArrowUpRight size={17} strokeWidth={2.4} aria-hidden="true" />
              </a>
            </figcaption>
          </figure>

          <dl
            className="trpc-tradeFloorSessions-stats"
            aria-label="Hosted theory room highlights"
          >
            {sessionStats.map((item) => (
              <div
                key={item.id}
                className="trpc-tradeFloorSessions-stat"
                data-trend={item.trend}
              >
                <dt>{item.label}</dt>
                <dd>{item.value}</dd>
              </div>
            ))}
          </dl>
        </article>
      </div>
    </section>
  );
}

export default TpcTradeFloorHostedSessions;